import React, { Component } from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { map } from 'lodash'

class Select extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentEle: undefined,
      selectedId: props.selectedId || undefined,
      isOpen: false
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.clearAll) {
      this.setState({ currentEle: undefined });
    }
  }

  render() {
    return (
      <div className="content sub-dropDown">
        {/* <select className="filter-select ">
                    <option value="Select Brand">Select Brand</option>
                    <option value="Select Modal">Select Modal</option>
                    <option value="Select Year">Select Year</option>
                    <option value="Select Brand">Select Brand</option>
                </select> */}
        {this.props.isJobService
          ?
          <DropdownButton bsSize="xsmall"
            onToggle={(e) => { this.setState({ isOpen: e }) }}
            title={
              <span>
                {!this.state.selectedId ? this.props.title : this.props.data[this.state.selectedId].displayname}
                <i className={this.state.isOpen ? "mdi mdi-chevron-up" : "mdi mdi-chevron-down"} />
              </span>
            }
            disabled={this.props.disabled}
            id="dropdown-size-extra-small"
            onSelect={(id, e) => { this.setState({ selectedId: id }); this.props.onChange(id, e.target.innerText) }} noCaret>
            {/* <MenuItem eventKey="Audi A3">Audi A3</MenuItem>
                      <MenuItem eventKey="Audi A4">Audi A4</MenuItem>
                      <MenuItem eventKey="Audi A6">Audi A6</MenuItem>
                      <MenuItem eventKey="Audi A6">Audi Q5</MenuItem>
                      <MenuItem eventKey="Audi A6">Audi S6</MenuItem> */}
            {map(this.props.data, (val) => {
              return (
                <MenuItem className={this.state.selectedId == val.id ? "active" : ""} eventKey={val.id} key={val.id}>{val.displayname}
                  <i className={this.state.selectedId == val.id ? "mdi mdi-check" : ""} />
                </MenuItem>
              )
            })}
          </DropdownButton>
          :
          <DropdownButton bsSize="xsmall" disabled={this.props.disabled}
            onToggle={(e) => { this.setState({ isOpen: e }) }}
            title={
              <span>
                {this.props.title}
                <i className={this.state.isOpen ? "mdi mdi-chevron-up" : "mdi mdi-chevron-down"} />
              </span>
            }
            id="dropdown-size-extra-small"
            onSelect={(e) => { this.setState({ currentEle: e }); this.props.onChange && this.props.onChange(e); }} noCaret>
            {/* <MenuItem eventKey="Audi A3">Audi A3</MenuItem>
                      <MenuItem eventKey="Audi A4">Audi A4</MenuItem>
                      <MenuItem eventKey="Audi A6">Audi A6</MenuItem>
                      <MenuItem eventKey="Audi A6">Audi Q5</MenuItem>
                      <MenuItem eventKey="Audi A6">Audi S6</MenuItem> */}
            {map(this.props.data, (ddValues, key) => {
              return (
                <MenuItem className={this.state.currentEle == ddValues ? "active" : ""} eventKey={ddValues} key={key}>{ddValues}
                  <i className={this.state.currentEle == ddValues ? "mdi mdi-check" : ""} />
                </MenuItem>
              )
            })}
          </DropdownButton>
        }
      </div>
    );
  }
}

export default Select;



// WEBPACK FOOTER //
// ./src/components/Results/Select.jsx